function createGroupTree (formFields) {
  var result = []
  var groupStack = []
  var lastGroupId = null
  for (var i = 0, l = formFields.length; i < l; i++) {
    var current = formFields[i]
    if (current.groupId !== undefined && current.groupId !== null && current.groupId !== 0) { // if field belongs to a group
      while (current.groupId !== lastGroupId) { // if not direct child of previous group (group was closed)
        groupStack.pop()
        if (groupStack.length > 0) {
          lastGroupId = groupStack[groupStack.length - 1].id
        } else {
          console.log('CHYBA: Nelze načíst položky, protože pole ' + current.id + ' je zařazeno v neexistující skupině groupId ' + current.groupId)
          return []
        }
      }
      groupStack[groupStack.length - 1].fields.push(current)
    } else { // if field is in root
      result.push(current)
    }
    if (current.fieldType === 'Group') { // if this field is group prepare for next field to be inserted into this group
      current.fields = []
      groupStack.push(current)
      lastGroupId = current.id
    }
  }
  return result
}

module.exports = createGroupTree
